module.exports = __webpack_public_path__ + "static/media/alert.655b1b73.svg";